// extracted by mini-css-extract-plugin
export default {"title-input-container":"components-settings-currency-conversion-modals-edit-title-module__title-input-container"};